<template>
  <div class="memberInfo">
    <div style="display:none">{{reload}}{{triggerTackingLead}}{{tackingLeadFlag}}</div>
    <div class="m-head">
      <div class="memberAvatar" style="cursor:pointer;" @click="openLeadUrl">
        <img
          :src="userProfile.image"
          width="100"
          onerror="onerror=null;src='../static/img/avatar-default.jpg'"
        />
        <div class="name">
          <h3>{{userProfile.leadName}}</h3>
        </div>
        <div style="margin-left: 90px;">
          <!-- 此socialLeadId有綁定普通名單且只有手機板才會顯示 -->
          <b-button
            v-if="mobileOnly(pairedBassisInfo.IsShowLeadInfo)"
            :href="'#/MobileLeadInfoView?ls=' + pairedBassisInfo.BindLeadSn"
            style="width: auto;height: auto;"
            size="sm"
            pill
            variant="success"
          >名單資訊</b-button>
          <!-- 此socialLeadId有綁定普通名單且主聯為操作者且只有手機板才會顯示 -->
          <b-button
            v-if="mobileOnly(pairedBassisInfo.IsShowBind)"
            :href="'#/MobileBindLeadAndSocialLeadView?sli=' + socialLeadId + '&tct=' + this.tutorChatToken"
            style="width: auto;height: auto;"
            size="sm"
            pill
            variant="info"
          >綁定一般名單</b-button>
        </div>
      </div>
    </div>
    <div style="height: 30px; background: #F5F5F5;"></div>
    <div class="memberTags foo4" id="memberTags">
      <b-tabs v-model="operatorIndex" card class="fullHeight" justified>
        <b-tab title="客戶畫像" active>
          <div class="socailID">
            <div class="lineID">
              <img src="../../../static/img/line-logo.png" alt />
              {{lineName}}
            </div>
            <div class="fbID">
              <img src="../../../static/img/fb-logo.png" alt />
              {{FbName}}
            </div>
            <div class="wechatID">
              <img src="../../../static/img/wechat_logo.svg" alt />
              {{WeChatName}}
            </div>
            <div class="weComID">
              <img src="../../../static/img/wecom_logo.png" alt />
              {{WeComName}}
            </div>
          </div>
          <div class="salesman">
            <table>
              <tr>
                <th>主聯業務</th>
                <td>{{userProfile.mainContact}}</td>
              </tr>
              <tr>
                <th>成交業務</th>
                <td>{{userProfile.dealSales}}</td>
              </tr>
              <tr>
                <th>操作人</th>
                <td>{{userProfile.operator}}</td>
              </tr>
            </table>
          </div>
          <div>
            <div class="mTagsRow classify">
              <label>分&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;類</label>
              <el-select v-model="userProfile.classData" filterable placeholder="請選擇">
                <el-option
                  v-for="item in user_classdata"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="mTagsRow birthday">
              <label>生&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</label>
              <el-date-picker
                v-model="pairedBassisInfo.Birthday"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="選擇日期"
              ></el-date-picker>
            </div>
            <div class="mTagsRow level">
              <label>語言程度</label>
              <el-select v-model="pairedBassisInfo.Learning_level" placeholder="語言程度">
                <el-option
                  v-for="item in learning_level"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="mTagsRow motivation">
              <label>學習動機</label>
              <el-select v-model="pairedBassisInfo.Learning_motivation" placeholder="學習動機">
                <el-option
                  v-for="item in learning_motivation"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                v-model="pairedBassisInfo.Learning_motivation_memo"
                v-show="learning_motivation_memo_show"
                placeholder="請輸入內容"
              ></el-input>
            </div>
            <div class="mTagsRow improve">
              <label>最想加強</label>
              <el-select v-model="pairedBassisInfo.Learning_important" placeholder="最想加強">
                <el-option
                  v-for="item in learning_important"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="mTagsRow custom">
              <label>自行定義</label>
              <el-input v-model="userProfile.tagName" placeholder="自行定義"></el-input>
            </div>
            <div class="mTagsRow note">
              <label>備註</label>
              <el-input
                type="textarea"
                placeholder="請輸入內容"
                v-model="pairedBassisInfo.Note"
                maxlength="300"
              ></el-input>
            </div>
            <el-button type="info" @click="save">儲存</el-button>
          </div>
        </b-tab>
        <b-tab title="追蹤明細" class="fullHeight">
          <TackingLeadInfoList
            v-if="operatorIndex==1"
            :socialLeadId="socialLeadId"
            :tutorChatToken="tutorChatToken"
          ></TackingLeadInfoList>
        </b-tab>
        <b-tab title="後續追蹤" v-if="operatorIsMainContact">
          <TackingLead
            v-if="operatorIndex==2"
            :socialLeadId="socialLeadId"
            :tutorChatToken="tutorChatToken"
          ></TackingLead>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>


<script>
import { SocialPairedBasisInfoHandler } from "../../handler/SocialPairedBasisInfoHandler.js";
import { SaleBusinessCardHandler } from "../../handler/SaleBusinessCardHandler";
import { ChatContainerHandler } from "../../handler/ChatContainerHandler.js";
import { isMobile } from "mobile-device-detect";
import store from "@/vuex/store_friendList.js";
import store_tackingLead from "@/vuex/store_tackingLead.js";
import TackingLead from "../Main/TackingLead";
import TackingLeadInfoList from "../Main/TackingLeadInfoList";

export default {
  name: "SocialLeadPairedBasisInfo", //客戶頭像
  components: {
    TackingLead,
    TackingLeadInfoList
  },
  props: ["socialLeadId", "staffID", "tutorChatToken"],
  created() {
    this.bind_data();
  },
  data() {
    return {
      token: "",
      operatorIndex: 0,
      userProfile: {
        name: "",
        leadName: "",
        image: "",
        mainContact: "",
        dealSales: "",
        operator: "",
        tagName: "",
        classData: "",
        leadUrl: "",
        userProfiles: [],
        isMobile
      },
      pairedBassisInfo: {
        SocialLeadId: "",
        Birthday: "",
        Learning_level: "",
        Learning_motivation: "",
        Learning_motivation_memo: "",
        Learning_important: "",
        Note: "",
        TagName: "",
        Classdata: "",
        IsShowBind: "",
        IsShowLeadInfo: "",
        BindLeadSn: "",
        //todo: 這個參數沒有用到了，必須從API開始刪除。
        IsShowClientRecord: ""
      },
      user_classdata: [
        {
          value: "0",
          label: " "
        },
        {
          value: "1",
          label: "NL-NA/新單-未成功聯繫"
        },
        {
          value: "2",
          label: "NL-NS/新單-未出席"
        },
        {
          value: "3",
          label: "NL-PD/新單-出席未付訂"
        },
        {
          value: "15",
          label: "NL-SCRM/新單-社群名單"
        },
        {
          value: "4",
          label: "CL-NA/結案單-未成功聯繫"
        },
        {
          value: "5",
          label: "CL-NS/結案單-未出席~5分鐘）"
        },
        {
          value: "6",
          label: "CL-PD/結案單-出席未付訂~5分鐘）"
        },
        {
          value: "14",
          label: "CL-SCRM/結案單-社群名單"
        },
        {
          value: "7",
          label: "MGM-NA/未成功聯繫"
        },
        {
          value: "8",
          label: "MGM-NS/未出席"
        },
        {
          value: "9",
          label: "MGM-PD/出席未付訂"
        },
        {
          value: "10",
          label: "PP/已付訂"
        },
        {
          value: "11",
          label: "CSR/已成交"
        },
        {
          value: "12",
          label: "RN/已續約"
        },
        {
          value: "13",
          label: "BM/已退費"
        }
      ],
      learning_level: [
        {
          value: "learning_level1",
          label: "低（可與外國人溝通3~5分鐘）"
        },
        {
          value: "learning_level2",
          label: "中（可與外國人溝通5~10分鐘）"
        },
        {
          value: "learning_level3",
          label: "高（可與外國人溝通10分鐘以上）"
        },
        {
          value: "learning_level4",
          label: "未知"
        }
      ],
      learning_important: [
        {
          value: "learning_important1",
          label: "會話"
        },
        {
          value: "learning_important2",
          label: "聽力"
        },
        {
          value: "learning_important3",
          label: "字彙"
        },
        {
          value: "learning_important4",
          label: "文法"
        },
        {
          value: "learning_important5",
          label: "閱讀"
        },
        {
          value: "learning_important6",
          label: "發音"
        }
      ],
      learning_motivation: [
        {
          value: "learning_motivation1",
          label: "工作"
        },
        {
          value: "learning_motivation2",
          label: "升學"
        },
        {
          value: "learning_motivation10",
          label: "留學"
        },
        {
          value: "learning_motivation3",
          label: "興趣"
        },
        {
          value: "learning_motivation4",
          label: "旅遊"
        },
        {
          value: "learning_motivation5",
          label: "自我充實"
        },
        {
          value: "learning_motivation6",
          label: "做生意"
        },
        {
          value: "learning_motivation7",
          label: "出國洽公"
        },
        {
          value: "learning_motivation8",
          label: "移民"
        },
        {
          value: "learning_motivation9",
          label: "其他"
        }
      ]
    };
  },
  methods: {
    openLeadUrl: function() {
      if (this.userProfile.leadUrl != null && !isMobile) {
        ChatContainerHandler.OpenURL(this.userProfile.leadUrl);
      }
    },
    mobileOnly: function(sourceBool) {
      return (
        sourceBool &&
        isMobile &&
        this.tutorChatToken != null &&
        this.tutorChatToken != undefined
      );
    },
    save: function() {
      var Learning_motivation;

      if (this.pairedBassisInfo.Learning_motivation != null) {
        Learning_motivation = this.pairedBassisInfo.Learning_motivation.toString();
      }
      var model = {
        socialLeadId: this.socialLeadId,
        birthday: this.pairedBassisInfo.Birthday,
        learning_level: this.pairedBassisInfo.Learning_level,
        learning_motivation: Learning_motivation,
        learning_motivation_memo: this.pairedBassisInfo
          .Learning_motivation_memo,
        learning_important: this.pairedBassisInfo.Learning_important,
        note: this.pairedBassisInfo.Note,
        tagName: this.userProfile.tagName,
        classdata: this.userProfile.classData
      };

      SocialPairedBasisInfoHandler.SaveSocialLeadPairedBasisInfo(
        model,
        this.staffID
      );
    },
    bind_data: function() {
      var staffInfo = SocialPairedBasisInfoHandler.GetStaffInfo(this.staffID);

      this.userProfile.operator =
        staffInfo.FirstName + " " + staffInfo.LastName;

      if (this.socialLeadId != undefined) {
        var socialLead = SocialPairedBasisInfoHandler.GetSocialLead(
          this.socialLeadId,
          this.staffID
        );

        //this.userProfile.name = socialLead.UserProfile.DisplayName;
        this.userProfile.image = socialLead.UserProfile.PictureUrl;
        this.userProfile.leadName = socialLead.LeadCname;
        this.userProfile.mainContact = socialLead.MainContactName;
        this.userProfile.leadUrl = socialLead.LeadUrl;
        this.userProfile.userProfiles = socialLead.UserProfiles;
        this.userProfile.dealSales = socialLead.DealSalesName;
        this.userProfile.tagName = "";
        this.userProfile.classData = "";
        if (socialLead.Tag != undefined) {
          this.userProfile.tagName = socialLead.Tag.Name;
        }

        if (socialLead.ClassData != undefined) {
          this.userProfile.classData = socialLead.ClassData.ListClassID;
        }

        //取得客戶頭像資料
        var pairedBasisInfo_ = SocialPairedBasisInfoHandler.GetSocialLeadPairedBasisInfo(
          this.socialLeadId,
          this.staffID
        );

        this.pairedBassisInfo = pairedBasisInfo_;
      }

      store_tackingLead.dispatch(
        "setOperatorIsMainContact",
        this.userProfile.mainContact == this.userProfile.operator
      );
    }
  },
  computed: {
    lineName() {
      var name = "";
      this.userProfile.userProfiles.forEach(element => {
        if (element.Provider.SocialNetwork == "0") {
          name = element.DisplayName;
        }
      });
      return name;
    },
    FbName() {
      var name = "";
      this.userProfile.userProfiles.forEach(element => {
        if (element.Provider.SocialNetwork == "1") {
          name = element.DisplayName;
        }
      });
      return name;
    },
    WeChatName() {
      var name = "";
      this.userProfile.userProfiles.forEach(element => {
        if (element.Provider.SocialNetwork == "10" && 
          (element.Provider.ProviderName=="WeChat" || element.Provider.ProviderName=="服務號-TutorABC麦奇好学")) {
          name = element.DisplayName;
        }
      });
      return name;
    },
    WeComName() {
      var name = "";
      this.userProfile.userProfiles.forEach(element => {
        if (element.Provider.SocialNetwork == "10" && element.Provider.ProviderName=="WeCom" ) {
          name = element.DisplayName;
        }
      });
      return name;
    },
    reload() {
      var flag = store.state.reload;
      var sociallead = store.state.socialLeadId;

      this.operatorIndex = 0;

      if (sociallead == null || sociallead == undefined || sociallead == "") {
        return "";
      }

      this.bind_data();
      return sociallead;
    },
    learning_motivation_memo_show() {
      if (this.pairedBassisInfo.Learning_motivation == null) {
        return false;
      }

      return (
        this.pairedBassisInfo.Learning_motivation.indexOf(
          "learning_motivation9"
        ) >= 0
      );
    },
    triggerTackingLead() {
      var careSn = store_tackingLead.state.careSn;
      this.operatorIndex = 2;
    },
    operatorIsMainContact() {
      return store_tackingLead.state.operatorIsMainContact;
    },
    tackingLeadFlag() {
      this.operatorIndex = 1;
      return store_tackingLead.state.flag;
    }
  }
};
</script>
<style>
#memberTags .card-header {
  background-color: #f5f5f5 !important;
}
#memberTags a {
  width: auto;
  color: #8c7b7b;
  font-size: 15px;
}
#memberTags .tab-content {
  height: calc(100% - 52px);
}
#memberTags .tab-content > .tab-pane {
  height: 100%;
  overflow: auto;
}
</style>
<style scoped>
.tool-bar a:hover {
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/SocialLeadPairedBasisInfo.vue